import StudentFormStepper from "@/components/forms/students/StudentFormStepper"
import { Scoped } from "@/components/forms/students/UseStudentFormStepper"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useStudentCreateStore } from "@/stores/useStudentCreateStore"
import { createFileRoute } from "@tanstack/react-router"
import { useMemo } from "react"

export const Route = createFileRoute("/beheer/cursisten/aanmaken")({
  component: RouteComponent,
})

function RouteComponent() {
  const personalStepData = useStudentCreateStore((s) => s.personalStepData)
  const projectStepData = useStudentCreateStore((s) => s.projectStepData)
  const initialStep: "contract" | "personal" = useMemo(() => {
    if (projectStepData && !personalStepData) return "personal"

    return "contract"
  }, [projectStepData, personalStepData])

  return (
    <ScreenWrapper showManagementMenu>
      <Scoped initialStep={initialStep}>
        <StudentFormStepper />
      </Scoped>
    </ScreenWrapper>
  )
}
